import { render, staticRenderFns } from "./CX-jlr.vue?vue&type=template&id=51d215e7&scoped=true&"
import script from "./CX-jlr.vue?vue&type=script&lang=js&"
export * from "./CX-jlr.vue?vue&type=script&lang=js&"
import style0 from "./CX-jlr.vue?vue&type=style&index=0&id=51d215e7&prod&scoped=true&lang=css&"
import style1 from "./CX-jlr.vue?vue&type=style&index=1&id=51d215e7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d215e7",
  null
  
)

export default component.exports